<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a href="">Configuracion</a></li>
        <li>
          <a class="link-effect" [routerLink]="['/configuracion', 'contratistas']">Contratistas</a>
        </li>
        <li><span class="link-effect">Registrar</span></li>
      </ol>
    </div>
  </div>
</div>

<div class="content">
  <div class="block">
    <form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>
      <div class="block-header">
        <h3 class="block-title">Registrar Contratista</h3>
      </div>
      <div class="block-content">
        <div class="form-horizontal">

          <div class="form-group">
            <label class="col-md-2 control-label">Contratista:</label>
            <div class="col-md-4">
              <mat-form-field appearance="outline">
                <mat-label>Contratista</mat-label>
                <input matInput type="text" [(ngModel)]="model.nombre" name="nombre" maxlength="40" required />
              </mat-form-field>
            </div>
            <label class="col-md-2 control-label">RUC:</label>
            <div class="col-md-3">
              <mat-form-field appearance="outline">
                <mat-label>RUC</mat-label>
                <input matInput type="text" [(ngModel)]="model.ruc" name="ruc" maxlength="13" pattern="^[A-Za-z0-9]*$"
                  (keypress)="keyPressNumberOnly($event)" required />
              </mat-form-field>
            </div>
          </div>
          <div class="form-group">
            <label class="col-md-2 control-label">Compañía:</label>
            <div class="col-md-4">
              <mat-form-field appearance="outline">
                <mat-label> Compañía </mat-label>
                <mat-select matSelect [(ngModel)]="model.selectedCompanias" name="selectedCompanias" multiple required>
                  <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                    {{ company.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <label class="col-md-2 control-label">Sedes:</label>
            <div class="col-md-4">
              <mat-form-field appearance="outline">
                <mat-label>Sedes</mat-label>
                <mat-select matSelect [(ngModel)]="model.selectedSedes" name="selectedSedes" multiple required>
                  <mat-option *ngFor="let sede of listaSedes" [value]="sede.idSede">
                    {{ sede.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="form-group">
            <label class="col-md-2 control-label">Estado:</label>
            <div class="col-md-2">
              <mat-form-field appearance="outline">
                <mat-label> Seleccione: </mat-label>
                <mat-select matSelect [(ngModel)]="model.idEstado" name="idEstado">
                  <mat-option *ngFor="let item of listaEstados; index as i" [value]="item.idParametroDetalle">{{
                    item.valor }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="block-content">
        <div class="form-horizontal">
          <mat-divider class="engie-divider"></mat-divider>
        </div>
        <mat-tab-group>
          <mat-tab label="Compañías - Sedes">
            <div class="form-horizontal">
              <div class="form-group">
                <div class="col-sm-12 text-right">
                  <button type="button" class="btn btn-new" mat-raised-button><mat-icon>description</mat-icon> Agregar
                    Compañía</button>

                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table mat-table [dataSource]="model.acciones" class="table table-striped table-vcenter">
              <ng-container matColumnDef="detalle">
                <th mat-header-cell *matHeaderCellDef>Detalle</th>
                <td mat-cell *matCellDef="let element">{{ element.detalle }}</td>
              </ng-container>

              <ng-container matColumnDef="fechalimite">
                <th mat-header-cell *matHeaderCellDef>Fecha Límite</th>
                <td mat-cell *matCellDef="let element" class="centre">{{ element.fechaLimite | date:'dd/MM/yyyy' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="fecharealcierre">
                <th mat-header-cell *matHeaderCellDef>Fecha Cierre Real</th>
                <td mat-cell *matCellDef="let element" class="centre">{{ element.fechaCierre | date:'dd/MM/yyyy' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element" class="centre">{{ element.estado }}</td>
              </ng-container>


              <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let element">
                  <button type="button" mat-icon-button color="primary" (click)="openDialogAccion(element)"
                    aria-label="Editar">
                    <mat-icon>create</mat-icon>
                  </button>
                  <button type="button" mat-icon-button color="primary" (click)="eliminarAccion(element)"
                    aria-label="Eliminar">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>

            </div>
          </mat-tab>
        </mat-tab-group>
      </div> -->
      <div class="block-content">
        <div class="form-horizontal pad-25">
          <div class="form-group">
            <div class="col-sm-12 text-right">
              <button type="submit" class="btn btn-naranja" [disabled]="modelForm.invalid" mat-raised-button>
                Guardar
              </button>
              <a class="btn btn-naranja2" mat-raised-button [routerLink]="['/configuracion/contratistas']">Cancelar</a>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>